/**
 * 此文件定义的方法用于动态改变的表格的表头和单元格样式的修改
 * 用法：在这个文件定义类似单页面的methods，然后用到混合 (mixins)  分发到各个组件
 */
export default {
  methods: {

    /**
     *  单元格的 style 的回调方法
     * @param row    可获取每一行数据的prop名，也就是数据源的key值
     * @param column  element官方文档对应的列名属性都可以获取到
     * @param rowIndex 行索引
     * @param columnIndex 列索引
     * @returns {string}  字符串类型的style样式
     */
    bodyCellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label === $t('integration.operation')||column.label === 'Operation') {
        return `text-align:center;`
      } else if(column.type === 'selection'){
        return `text-align:center;`
      }else{
        return `text-align:left;`
      }
    },

    // 表头行的 style 的回调方法 注意：16进制和rgb的颜色不能加引号
    // background-color 由 element-theme-overrides.scss 中的 .el-table__cell 覆盖（!important）
    headCellStyle({ row, column, rowIndex, columnIndex }) {
      let baseStyle = `background-color:transparent;color:#fff;height: '40px';border-color: rgb(197, 208, 218);`
      if (column.label === $t('integration.operation')||column.label === 'Operation') {
        return baseStyle+`text-align:center;`
      } else if(column.type === 'selection'){
        return baseStyle+`text-align:center;`
      }else{
        return baseStyle+`text-align:left;`
      }
    },


    /**
     * 动态生成随机的key值
     * @returns {number}
     */
    randomTableKey(){
      return Math.random().toString()
    },

  }
}
